module.exports = __webpack_public_path__ + "i18n/ko_657391b6c5469f02fe01d5dacbb9c503.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/m_ko.properties
// module id = aSTO
// module chunks = 118